import { disableSubmitButton } from 'formifier';
import _ from 'lodash';
import LockWrapper from './lockWrapper/lockWrapper';
import { WrappedElement } from './WrappedElement';
import ow from 'ow';
import { notBlankValidator } from './owValidators';

export const AUTOFOCUS_CALLBACK = {
  company: 'company',
  signIn: 'signIn',
  signUp: 'signUp',
  forgotPassword: 'forgotPassword',
  default: 'default',
};

export class Renderer {
  constructor(
    lockWrapper,
    backToSignInViewState,
    wrappedElements,
    autofocuser,
    auth0Domain,
    handlingErrors
  ) {
    if (!(lockWrapper instanceof LockWrapper)) {
      throw new Error('Expected lockWrapper to be a LockWrapper');
    }
    if (!_.isFunction(backToSignInViewState)) {
      throw new Error('Expected backToSignInViewState to be a function');
    }
    if (!this.isValidWrappedElements(wrappedElements)) {
      throw new Error(
        'Expected wrappedElements to be a collection of WrappedElements'
      );
    }
    ow(auth0Domain, 'auth0Domain', ow.string.validate(notBlankValidator));

    this.lockWrapper = lockWrapper;
    this.backToSignInViewState = backToSignInViewState;
    this.wrappedElements = wrappedElements;
    this.autofocuser = autofocuser;
    this.auth0Domain = auth0Domain;
    this.handlingErrors = handlingErrors;
  }

  isValidWrappedElements(elements) {
    if (!(_.isPlainObject(elements) && _.size(elements) > 0)) {
      return false;
    }

    return _.every(elements, (el) => el instanceof WrappedElement);
  }

  toggleVisibility(els, view) {
    _.forEach(els, (value) => {
      value.toggleVisibility(view);
    });
  }

  updateText(els, view) {
    _.forEach(els, (value) => {
      value.updateText(view);
    });
  }

  redirectToConnection(newConnection, emailAddress, auth0Domain) {
    let params = new URLSearchParams(window.location.search);
    params.set('connection', newConnection);
    if (newConnection === 'sharecare-inc') {
      if (params.has('state')) {
        params.delete('state');
      }
    }
    if (params.has('client')) {
      params.set('client_id', params.get('client'));
      params.delete('client');
    }
    if (!_.isNil(emailAddress)) {
      params.set('login_hint', emailAddress);
    }
    window.location = `https://${auth0Domain}/authorize?${params}`;
  }

  render(viewState) {
    if (viewState.federatedConnection) {
      this.redirectToConnection(
        viewState.federatedConnection,
        viewState.email,
        this.auth0Domain
      );
      return;
    }

    if (viewState.isEmailFormVisible) {
      disableSubmitButton(this.wrappedElements.emailForm.element, false);
    }

    this.updateText(this.wrappedElements, viewState);
    this.toggleVisibility(this.wrappedElements, viewState);

    this.lockWrapper.render(
      viewState.lockState,
      this.handlingErrors(() => this.autofocuser.start(viewState.screenName)),
      this.handlingErrors((screenName) => {
        this.wrappedElements.auth0WrapperDiv.setAttribute(
          'data-analytics-form',
          `auth0_lock_${screenName}`
        );
        document.dispatchEvent(new CustomEvent('formUpdate'));
      }),
      this.handlingErrors(() =>
        this.backToSignInViewState().then((vs) => this.render(vs))
      )
    );
  }
}
